import axios from "axios";
import React, { Fragment, useCallback, useEffect, useRef, useState } from "react";
import {
  addSupportIssue,
  // assignServers,
  createApiKey,
  // createNewRazorPayOrder,
  createUser
  // getRazorPayKey,
  // getUserInfo,
  // login,
  // provisionSaasServer,
} from "../../api";
import {
  // Link,
  useNavigate,
  useSearchParams
  // createSearchParams,
} from "react-router-dom";
// import { useFormik } from "formik";
import { useGoogleLogin } from "@react-oauth/google";
// import { SET_SNACKBAR } from "@/redux/types";
import {
  authTokenPayload,
  classNames,
  // b64EncodeUnicode,
  countries,
  generatePassword,
  generateRandomInt,
  getGitHubUrl,
  supportGroup,
  supportPipe,
  supportWork
} from "../../config/constant";
import { useFormik } from "formik";
import { Alert, Box, Popover, Snackbar } from "@mui/material";
import { CheckCircleIcon } from "@heroicons/react/20/solid";
import { useAuth } from "../../Providers/AuthProvider";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { useAppProvider } from "../../Providers/appProvider/AppProvider";
import { GlobalActionTypes } from "../../Providers/appProvider/reducers/globalReducer";
import { cloudServiceBaseUrl, userServiceBaseUrl } from "../../config";
import { createBillingCustomer, updateAccountInfo } from "../../api/utils/user";
import { isValidEmail, useEmailOtp } from "../../hooks/useEmailOtp";

function Signup({
  setOpen = () => {},
  setOpenChoosePlan = () => {},
  render_type,
  appDetail,
  freeTrial,
  purchase = () => {}
}) {
  const { dispatch } = useAppProvider();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // const code = searchParams.get("code");
  const code = searchParams.get("code");
  const state = searchParams.get("state");
  const ref = searchParams.get("ref");

  const signinRef = useRef(null);
  const { refreshUserInfo } = useAuth();

  const [bgImage, setBgImage] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [successAlert, setSuccessAlert] = useState(false);
  // const [captchaCheck, setCaptchaCheck] = useState(false);
  const [country, setCountry] = useState({
    label: "India",
    phone: "91",
    code: "in"
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    severity: "info",
    msg: ""
  });

  const notify = useCallback(({ severity, msg }) => {
    setSnackbar({ open: true, severity, msg });
  }, []);

  const formik = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      email: "",
      phone: ""
    },
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      // The OTP gate only applies to this form. The Google/GitHub handlers call
      // signupUser directly with a provider-verified address, so they skip it.
      if (!emailVerified) {
        notify({
          severity: "warning",
          msg: "Please verify your email address before signing up"
        });

        return;
      }

      try {
        // const res = await handleCaptcha();
        // console.log(res);
        // if (res?.success === false) {
        //   setSnackbar({
        //     open: true,
        //     severity: "error",
        //     msg: "Can't proceed with the signup, Try Again",
        //   });
        // } else {
        // must be awaited, otherwise formik flips isSubmitting back to false as soon as
        // signupUser hits its first await and the button spinner only flashes
        await signupUser(values.email, values.first_name, values.last_name, values.phone);
        // }
      } catch (error) {
        setSnackbar({
          open: true,
          severity: "error",
          msg: "Can't proceed with the signup, Try Again"
        });
        console.log(error);
      }
    }
  });

  // Declared after formik because it needs the live email value. onSubmit above
  // only reads emailVerified when the user actually submits, long after this runs.
  const {
    otp,
    otpSent,
    emailVerified,
    sendingOtp,
    verifyingOtp,
    resendIn,
    otpLength,
    sendOtp,
    verifyOtp,
    setOtp
  } = useEmailOtp({ email: formik.values.email, notify });

  const emailLooksValid = isValidEmail(formik.values.email);

  const generateApiKey = async (userid) => {
    try {
      const res = await createApiKey(
        JSON.stringify(
          authTokenPayload({
            userid
          })
        )
      );

      return res?.apikey;
      //   loginUser(userid, "forum_user_pwd");
    } catch (error) {
      console.log(error);
      reportIssue(
        `Api key generation failed for user ${userid}`,
        `<p>Error Message</p><br/><br/><p>${error}</p>`
      );
    }
  };

  const signupUser = async (email, first_name, last_name, phone) => {
    try {
      formik.setSubmitting(true);
      let errors = [];
      const password = generatePassword();

      dispatch({
        type: GlobalActionTypes.SET_PASSWORD,
        payload: password
      });

      const payload = authTokenPayload({
        user_info: {
          userid: email,
          email,
          first_name,
          last_name,
          name: first_name + " " + last_name,
          phone: phone ? `+${country?.phone} ${phone}` : undefined,
          license: "LSAAS",
          status: 3,
          user_type: "POWER",
          country: country?.label,
          // NO power_user here. It is a reference to a parent/owner account, so sending
          // "" makes the user service resolve a user with an empty id and reject the
          // whole signup with "user doesn't exist, authentication failed".
          pwd: password
        },

        signup: 1
      });

      if (email?.length < 8 || email?.length > 48) {
        errors.push(
          "The email address can't be less than 8 chars and more than 48 chars, chose another id"
        );
      }

      if (first_name?.length > 48) {
        errors.push("First name can't be more than 48 chars");
      }

      if (last_name?.length > 48) {
        errors.push("Last name can't be more than 48 chars");
      }

      if (phone?.length > 10) {
        errors.push("Phone number is too long - Max limit 10 chars");
      }

      if (phone) {
        let isVerificationSuccessful = false;

        const apiPromise = new Promise(async (resolve) => {
          try {
            const response = await axios.get(
              `https://api-bdc.net/data/phone-number-validate?number=${phone}&countryCode=${country?.code}&localityLanguage=en&key=${process.env.REACT_APP_PHONE_VALIDATION_API_KEY}`
            );

            resolve(response.data);
          } catch (error) {
            console.error("API call failed:", error);
            resolve(undefined);
          }
        });

        const result = await Promise.race([
          apiPromise,
          new Promise((resolve) => setTimeout(resolve, 5000))
        ]);

        if (result) {
          if (result?.isValid === true) {
            isVerificationSuccessful = true;
          } else {
            isVerificationSuccessful = false;
          }
        } else {
          isVerificationSuccessful = true;
        }

        if (!isVerificationSuccessful) {
          errors.push(
            "Phone number seems invalid. Please re-check the phone number that you've entered"
          );
        }
      }

      if (errors?.length > 0) {
        setSnackbar({
          open: true,
          severity: "error",
          msg: errors[0]
        });

        formik.setSubmitting(false);
      } else {
        const creation = await createUser(payload);

        if (creation?.errcode === 0) {
          setSnackbar({
            open: true,
            severity: "success",
            msg: "User creation successful - Your password has been sent to your email address"
          });

          try {
            const apikey = await generateApiKey(email);

            // must be awaited - everything below (billing customer, account info,
            // ChoosePlan) reads userInfo back out of sessionStorage
            if (apikey) {
              await refreshUserInfo(email, apikey);
            }

            const email_payload = {
              mail_template_key:
                "2518b.2f361ca8e178de0f.k1.1aeeb640-ae07-11ee-b95b-525400b0b0f3.18ce85f37a4",
              from: {
                address: "welcome@bangdb.com",
                name: "BangDB NoSQL"
              },
              to: [
                {
                  email_address: {
                    address: email,
                    name: first_name + " " + last_name
                  }
                }
              ],
              merge_info: {
                password,
                first_name,
                userid: email,
                ampere_uri: process.env.REACT_APP_AMPERE_URI,
                appstore_uri: window.location.host,
                subject: "Welcome to BangDB AppStore - Your account has been created"
              },
              subject: "Welcome to BangDB AppStore - Your account has been created"
            };
            let emailSent = true;

            try {
              await axios.post(`https://cloud.bangdb.com/auth/zeptoMail/send_mail`, email_payload);
            } catch (error) {
              console.log("Email sending failed:", error);
              emailSent = false;
            }

            dispatch({
              type: GlobalActionTypes.SET_PASSWORD,
              payload: password
            });

            setOpen(false);

            const createCustomer = await createBillingCustomer({
              display_name: first_name + " " + last_name,
              first_name,
              last_name,
              email,
              company_name: "",
              mobile: Number(phone),
              custom_fields: [
                {
                  label: "us",
                  value: userServiceBaseUrl
                }
              ]
            });

            const zoho_customer_id = createCustomer?.customer?.customer_id;

            // a missing billing account must not block the signup - the user exists and
            // can still be onboarded, purchase() creates the customer on the fly later
            if (zoho_customer_id) {
              try {
                await updateAccountInfo({
                  userid: payload.user_info.userid,
                  apikey,
                  zoho_customer_id
                });
              } catch (error) {
                console.error("Failed to save the billing customer id", error);
              }
            } else {
              console.error("Failed to create billing account for the user");
            }

            setOpenChoosePlan(true);

            if (render_type === "page") {
              navigate(`/`);
            }

            if (!emailSent) {
              setSnackbar({
                open: true,
                severity: "warning",
                msg: `We couldn't send the email, but your account has been created. Please continue the process.`
              });
            }
            // formik.resetForm();
            // setSuccessAlert(true);
          } catch (error) {
            console.log(error);

            reportIssue(
              `Api key generation failed for user ${email}`,
              `<p>Error Message</p><br/><br/><p>${error}</p>`
            );

            setSnackbar({
              open: true,
              severity: "error",
              msg: `API key generation failed, please write us a mail at info@bangdb.com or try again`
            });
          }
        } else {
          let err;

          switch (creation?.error?.[0]) {
            case `user already exists, create user failed`:
              err = `<p>This email is already registered, Please <a style="text-decoration: underline;" class="text-blue-600" href="/auth/login">click here</a> to sign in</p>`;
              break;

            default:
              err = creation?.error?.[0];
              break;
          }

          setSnackbar({
            open: true,
            severity: "error",
            msg: err ? err : "User creation failed"
          });
        }
      }
    } catch (error) {
      console.log(error);
    }

    formik.setSubmitting(false);
  };

  const signupWithGithub = async (accessCode) => {
    try {
      formik.setSubmitting(true);

      const res = await axios.post(`https://${cloudServiceBaseUrl}/auth/github/get_access_token`, {
        code: accessCode
      });

      if (res?.data?.access_token) {
        const profile = await axios.get(`https://api.github.com/user`, {
          headers: {
            Authorization: `Bearer ${res?.data?.access_token}`
          }
        });

        const emails = await axios.get(`https://api.github.com/user/emails`, {
          headers: {
            Authorization: `Bearer ${res?.data?.access_token}`
          }
        });

        const primaryEmail = emails?.data?.find((obj) => obj?.primary === true)?.email;

        if (primaryEmail) {
          await signupUser(
            primaryEmail,
            profile?.data?.name?.split(" ")?.[0],
            profile?.data?.name?.split(" ")?.[1],
            profile?.data?.phone
          );
        }

        formik.setSubmitting(false);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const signupWithGoogle = useGoogleLogin({
    onSuccess: (tokenResponse) => {
      // console.log("success", tokenResponse);
      axios
        .get(
          `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${tokenResponse?.access_token}`,
          {
            headers: {
              Authorization: `Bearer ${tokenResponse?.access_token}`,
              Accept: "application/json"
            }
          }
        )
        .then(async (res) => {
          if (res?.data?.email) {
            await signupUser(
              res.data?.email,
              res.data?.given_name,
              res.data?.family_name,
              res.data?.phone
            );
          }
        })
        .catch((err) => console.log(err));
    },
    onError: (tokenResponse) => console.log("error", tokenResponse)
  });

  const reportIssue = async (title, description) => {
    const payload = {
      doc: {
        title,
        _desc_: description,
        c_f: {},
        _meta: {
          tags: ["App Store"],
          pri: 4,
          s: "Open",
          r: "appstore_frontend",
          c: "Signup",
          cat: "None",
          state: "None",
          due_date: "",
          created_time: Date.now() * 1000,
          files: []
        }
      },
      work_name: process.env.REACT_APP_SUPPORT_WORK,
      groupid: process.env.REACT_APP_SUPPORT_GROUP,
      pipeid: process.env.REACT_APP_SUPPORT_PIPE,
      userid: "forum_admin"
    };

    try {
      await addSupportIssue(payload);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (code) {
      signupWithGithub(code);
    }
  }, [code]);

  useEffect(() => {
    if (!bgImage) {
      const img = randomImages[generateRandomInt(0, 1)];
      setBgImage(img);
    }
  }, []);

  const handleCaptcha = async (_) => {
    return new Promise((resolve, reject) => {
      window.grecaptcha.enterprise.ready(async (_) => {
        const token = await window.grecaptcha.enterprise.execute(
          process.env.REACT_APP_GOOGLE_SITE_KEY,
          { action: "submit" }
        );

        const response = await axios(`https://${cloudServiceBaseUrl}/auth/verify-recaptcha`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          data: { token }
        });

        return resolve(response?.data);
      });
    });
  };

  useEffect(() => {
    // Add reCaptcha
    const script = document.createElement("script");
    script.src = `https://www.google.com/recaptcha/enterprise.js?render=${process.env.REACT_APP_GOOGLE_SITE_KEY}`;
    document.body.appendChild(script);
  }, []);

  return (
    <>
      {/* keyed on the message so each one remounts the Snackbar and gets its own
          auto-hide window - without this a follow-up message (the OTP flow emits
          several in a row) inherits the previous timer and can vanish instantly */}
      <Snackbar
        key={snackbar.msg}
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={(_, reason) => {
          // Snackbar ships a ClickAwayListener, so without this the same click that
          // triggers a message dismisses it again. OTP verification is synchronous,
          // so "Incorrect code..." was being wiped before it ever painted.
          if (reason === "clickaway") return;

          setSnackbar({ open: false, msg: "", severity: "info" });
        }}
      >
        <Alert
          onClose={() => setSnackbar({ open: false, msg: "", severity: "info" })}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          <div dangerouslySetInnerHTML={{ __html: snackbar.msg }}></div>
          {/* {snackbar.msg} */}
        </Alert>
      </Snackbar>

      <div className="flex min-h-full flex-1">
        <div className="flex flex-1 flex-col justify-center px-4 py-12 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
          <div className="mx-auto w-full max-w-sm lg:w-96">
            <div>
              <h2 className="mt-8 text-2xl font-bold leading-9 tracking-tight text-gray-900">
                Sign up to BangDB
              </h2>
              <p className="mt-2 text-sm leading-6 text-gray-500">
                Already a member?{" "}
                <a
                  href={ref ? `/auth/login?ref=${ref}` : "/auth/login"}
                  className="font-semibold text-indigo-600 hover:text-indigo-500 focus:ring-2 focus:ring-indigo-600"
                  ref={signinRef}
                >
                  Sign in
                </a>
              </p>
            </div>

            <div className="mt-10">
              <div className="mt-10">
                {successAlert && (
                  <div className="rounded-md bg-green-50 p-4 my-8">
                    <div className="flex">
                      <div className="flex-shrink-0">
                        <CheckCircleIcon className="h-5 w-5 text-green-400" aria-hidden="true" />
                      </div>
                      <div className="ml-3">
                        <h3 className="text-sm font-medium text-green-800">
                          Account Created Successfully
                        </h3>
                        <div className="mt-2 text-sm text-green-700">
                          <p>
                            You have successfully signed-up for BangDB AppStore. You'll receive a
                            confirmation mail from us with userid and password which you can use to
                            login. Alternatively, you can also authenticate with Google or Github
                            without using your password.
                          </p>
                        </div>
                        <div className="mt-4">
                          <div className="-mx-2 -my-1.5 flex">
                            <button
                              type="button"
                              className="rounded-md bg-green-50 px-2 py-1.5 text-sm font-medium text-green-800 hover:bg-green-100 focus:outline-none focus:ring-2 focus:ring-green-600 focus:ring-offset-2 focus:ring-offset-green-50"
                              onClick={() => navigate(`/auth/login`)}
                            >
                              Go to Login page
                            </button>
                            <button
                              type="button"
                              className="ml-3 rounded-md bg-green-50 px-2 py-1.5 text-sm font-medium text-green-800 hover:bg-green-100 focus:outline-none focus:ring-2 focus:ring-green-600 focus:ring-offset-2 focus:ring-offset-green-50"
                              onClick={() => setSuccessAlert(false)}
                            >
                              Dismiss
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <form
                  className="space-y-6"
                  onSubmit={(e) => {
                    e.preventDefault();

                    // bdbForm comes from the Matomo container script, which is loaded
                    // async from a CDN and is routinely blocked by ad blockers. It must
                    // never be able to stop the signup from going through.
                    try {
                      window.bdbForm?.(e, "SIGN_UP", {
                        type: "",
                        value: "SIGN_UP"
                      });
                    } catch (error) {
                      console.error("Form tracking failed", error);
                    }

                    formik.handleSubmit(e);
                  }}
                >
                  <div className="grid grid-cols-1 gap-4">
                    <div className="col-span-1">
                      <div>
                        <label
                          htmlFor="first_name"
                          className="block text-sm font-medium leading-6 text-gray-900"
                        >
                          First Name
                        </label>
                        <div className="mt-2">
                          <input
                            id="analysis_attr1"
                            name="first_name"
                            type="text"
                            autoComplete="first_name"
                            required
                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 px-2 focus:outline-none"
                            value={formik.values.first_name}
                            onChange={formik.handleChange}
                            maxLength="48"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-span-1">
                      <div>
                        <label
                          htmlFor="last_name"
                          className="block text-sm font-medium leading-6 text-gray-900"
                        >
                          Last Name
                        </label>
                        <div className="mt-2">
                          <input
                            id="analysis_attr2"
                            name="last_name"
                            type="text"
                            autoComplete="last_name"
                            required
                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 px-2 focus:outline-none"
                            value={formik.values.last_name}
                            onChange={formik.handleChange}
                            maxLength="48"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-span-1">
                      <div>
                        <label
                          htmlFor="email"
                          className="block text-sm font-medium leading-6 text-gray-900"
                        >
                          Email address
                        </label>
                        <div className="mt-2 flex gap-2">
                          <input
                            id="email"
                            name="email"
                            type="email"
                            autoComplete="email"
                            required
                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 px-2 focus:outline-none disabled:bg-gray-50 disabled:text-gray-500"
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            maxLength="48"
                            disabled={emailVerified}
                          />

                          {emailVerified ? (
                            <span className="inline-flex shrink-0 items-center gap-1 rounded-md bg-green-50 px-3 text-sm font-medium text-green-700 ring-1 ring-inset ring-green-200">
                              <CheckCircleIcon className="h-4 w-4" aria-hidden="true" />
                              Verified
                            </span>
                          ) : (
                            <button
                              type="button"
                              onClick={sendOtp}
                              disabled={sendingOtp || !emailLooksValid || resendIn > 0}
                              className="shrink-0 rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:cursor-not-allowed disabled:bg-indigo-400"
                            >
                              {sendingOtp
                                ? "Sending..."
                                : resendIn > 0
                                  ? `Resend in ${resendIn}s`
                                  : otpSent
                                    ? "Resend code"
                                    : "Send code"}
                            </button>
                          )}
                        </div>

                        {otpSent && !emailVerified && (
                          <div className="mt-3">
                            <label
                              htmlFor="otp"
                              className="block text-sm font-medium leading-6 text-gray-900"
                            >
                              Verification code
                            </label>
                            <p className="text-xs leading-5 text-gray-500">
                              Sent to {formik.values.email}
                            </p>
                            <div className="mt-2 flex gap-2">
                              <input
                                id="otp"
                                name="otp"
                                type="text"
                                inputMode="numeric"
                                autoComplete="one-time-code"
                                placeholder={`${otpLength} digit code`}
                                className="block w-full rounded-md border-0 py-1.5 tracking-[0.3em] text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:tracking-normal placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 px-2 focus:outline-none"
                                value={otp}
                                onChange={(e) => setOtp(e.target.value)}
                                maxLength={otpLength}
                              />

                              <button
                                type="button"
                                onClick={verifyOtp}
                                disabled={verifyingOtp || otp.length !== otpLength}
                                className="shrink-0 rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:cursor-not-allowed disabled:bg-indigo-400"
                              >
                                {verifyingOtp ? "Verifying..." : "Verify"}
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-span-1">
                      <div>
                        <label
                          htmlFor="phone"
                          className="block text-sm font-medium leading-6 text-gray-900"
                        >
                          Phone Number
                        </label>
                        <div className="mt-2 flex">
                          <span
                            className="inline-flex items-center rounded-l-md px-3 ring-0 ring-inset ring-gray-300 text-gray-500 sm:text-sm shadow-sm focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:leading-6 leading-6 focus:outline-none cursor-pointer"
                            onClick={(e) => setAnchorEl(e.currentTarget)}
                          >
                            <Box
                              component="li"
                              sx={{
                                listStyle: "none",
                                width: 80,
                                display: "flex",
                                alignItems: "center",
                                columnGap: 1
                              }}
                            >
                              <img
                                loading="lazy"
                                width="20"
                                style={{
                                  height: 13
                                }}
                                src={`https://flagcdn.com/w20/${countries
                                  ?.find((c) => c.label === country?.label)
                                  ?.code?.toLowerCase()}.png`}
                                alt=""
                              />
                              <span>+{country?.phone}</span>
                              {anchorEl ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                            </Box>
                          </span>

                          <input
                            id="phone"
                            name="phone"
                            type="tel"
                            autoComplete="phone"
                            required
                            className="block w-full rounded-r-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 px-2 focus:outline-none"
                            value={formik.values.phone}
                            onChange={(e) => {
                              const regex = /^\d*$/;

                              if (regex.test(e.target.value) || e.target.value === "") {
                                formik.handleChange(e);
                              }
                            }}
                            maxLength="10"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-span-1">
                      <div className="flex items-center">
                        <input
                          id="remember-me"
                          name="remember-me"
                          required
                          type="checkbox"
                          className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                        />
                        <label
                          htmlFor="remember-me"
                          className="ml-3 block text-sm leading-6 text-gray-700"
                        >
                          I agree to the{" "}
                          <a
                            href="https://bangdb.com/terms-and-conditions"
                            target="_blank"
                            className="text-blue-600 border-b border-b-blue-600"
                          >
                            terms & conditions
                          </a>
                        </label>
                      </div>
                    </div>

                    <div className="col-span-1">
                      <div
                        className="g-recaptcha"
                        data-sitekey={process.env.REACT_APP_GOOGLE_SITE_KEY}
                        data-size="invisible"
                      ></div>
                    </div>
                  </div>

                  <Popover
                    id={Boolean(anchorEl) ? "simple-popover" : undefined}
                    open={Boolean(anchorEl)}
                    anchorEl={anchorEl}
                    onClose={() => setAnchorEl(null)}
                    classes={{
                      paper: "custom-status-popup-dropdown"
                    }}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "left"
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "left"
                    }}
                  >
                    <div className="max-h-[25vh] min-w-[250px] relative overflow-x-hidden overflow-y-auto text-left custom-scroll">
                      {countries?.map((country, index) => (
                        <Fragment key={index}>
                          <div
                            className="custom-status-popup-list-item"
                            onClick={() => {
                              setCountry({
                                label: country?.label,
                                phone: country?.phone,
                                code: country?.code?.toLowerCase()
                              });

                              setAnchorEl(null);
                            }}
                          >
                            <div className="flex items-center justify-start p-2 hover:bg-gray-100 cursor-pointer">
                              <img
                                src={`https://flagcdn.com/w20/${country?.code?.toLowerCase()}.png`}
                                // src="/icons/user-icon.png"
                                className="w-[20px] h-[13px]"
                              />

                              <span className="ml-4">
                                <span className="mr-3">+{country?.phone}</span>
                                <span className="mr-3">{country?.label}</span>
                                <span className="">({country?.code})</span>
                              </span>
                            </div>
                          </div>
                        </Fragment>
                      ))}
                    </div>
                  </Popover>

                  <div>
                    <button
                      type="submit"
                      // disabled={formik.isSubmitting || captchaCheck === false}
                      disabled={formik.isSubmitting || !emailVerified}
                      className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:cursor-not-allowed disabled:bg-indigo-400"
                    >
                      {formik.isSubmitting ? (
                        // h-6 matches the button's leading-6 text so it does not resize
                        <svg
                          aria-label="Signing up"
                          role="status"
                          className="w-6 h-6 text-indigo-200 animate-spin fill-white"
                          viewBox="0 0 100 101"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="currentColor"
                          />
                          <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="currentFill"
                          />
                        </svg>
                      ) : (
                        "Sign up"
                      )}
                    </button>

                    {!emailVerified && (
                      <p className="mt-2 text-center text-xs leading-5 text-gray-500">
                        Verify your email address to enable sign up
                      </p>
                    )}
                  </div>
                </form>

                <div className="relative mt-4">
                  <div className="absolute inset-0 flex items-center" aria-hidden="true">
                    <div className="w-full border-t border-gray-200" />
                  </div>
                  <div className="relative flex justify-center text-sm font-medium leading-6">
                    <span className="bg-white px-6 text-gray-900">Continue with</span>
                  </div>
                </div>

                <div className="mt-6 grid grid-cols-2 gap-4">
                  <a
                    className="flex w-full items-center justify-center gap-3 rounded-md bg-white shadow-md border px-3 py-1.5 text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#1D9BF0] cursor-pointer"
                    onClick={() => signupWithGoogle()}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      version="1.1"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                      width="512"
                      height="512"
                      x="0"
                      y="0"
                      viewBox="0 0 512 512"
                      // style="enable-background:new 0 0 512 512"
                      xmlSpace="preserve"
                      className="w-5 h-5"
                    >
                      <g>
                        <path
                          d="m492.668 211.489-208.84-.01c-9.222 0-16.697 7.474-16.697 16.696v66.715c0 9.22 7.475 16.696 16.696 16.696h117.606c-12.878 33.421-36.914 61.41-67.58 79.194L384 477.589c80.442-46.523 128-128.152 128-219.53 0-13.011-.959-22.312-2.877-32.785-1.458-7.957-8.366-13.785-16.455-13.785z"
                          // style=""
                          fill="#167ee6"
                          data-original="#167ee6"
                          // class=""
                        ></path>
                        <path
                          d="M256 411.826c-57.554 0-107.798-31.446-134.783-77.979l-86.806 50.034C78.586 460.443 161.34 512 256 512c46.437 0 90.254-12.503 128-34.292v-.119l-50.147-86.81c-22.938 13.304-49.482 21.047-77.853 21.047z"
                          // style=""
                          fill="#12b347"
                          data-original="#12b347"
                        ></path>
                        <path
                          d="M384 477.708v-.119l-50.147-86.81c-22.938 13.303-49.48 21.047-77.853 21.047V512c46.437 0 90.256-12.503 128-34.292z"
                          // style=""
                          fill="#0f993e"
                          data-original="#0f993e"
                        ></path>
                        <path
                          d="M100.174 256c0-28.369 7.742-54.91 21.043-77.847l-86.806-50.034C12.502 165.746 0 209.444 0 256s12.502 90.254 34.411 127.881l86.806-50.034c-13.301-22.937-21.043-49.478-21.043-77.847z"
                          // style=""
                          fill="#ffd500"
                          data-original="#ffd500"
                          // class=""
                        ></path>
                        <path
                          d="M256 100.174c37.531 0 72.005 13.336 98.932 35.519 6.643 5.472 16.298 5.077 22.383-1.008l47.27-47.27c6.904-6.904 6.412-18.205-.963-24.603C378.507 23.673 319.807 0 256 0 161.34 0 78.586 51.557 34.411 128.119l86.806 50.034c26.985-46.533 77.229-77.979 134.783-77.979z"
                          // style=""
                          fill="#ff4b26"
                          data-original="#ff4b26"
                        ></path>
                        <path
                          d="M354.932 135.693c6.643 5.472 16.299 5.077 22.383-1.008l47.27-47.27c6.903-6.904 6.411-18.205-.963-24.603C378.507 23.672 319.807 0 256 0v100.174c37.53 0 72.005 13.336 98.932 35.519z"
                          // style=""
                          fill="#d93f21"
                          data-original="#d93f21"
                        ></path>
                      </g>
                    </svg>
                    <span className="text-sm font-semibold leading-6 text-black">Google</span>
                  </a>

                  <a
                    // href="#"
                    className="flex w-full items-center justify-center gap-3 rounded-md bg-[#24292F] px-3 py-1.5 text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#24292F] cursor-pointer"
                    onClick={() => {
                      window.location.assign(getGitHubUrl(window.location.pathname));
                    }}
                  >
                    <svg
                      className="h-5 w-5"
                      aria-hidden="true"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10 0C4.477 0 0 4.484 0 10.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0110 4.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.203 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.942.359.31.678.921.678 1.856 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0020 10.017C20 4.484 15.522 0 10 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                    <span className="text-sm font-semibold leading-6">GitHub</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className={classNames(
            "relative hidden w-0 flex-1 lg:block ",
            render_type !== "page" ? "rounded-r-xl h-[95vh]" : "h-screen"
          )}
        >
          <img
            className={classNames(
              "absolute inset-0 h-full w-full object-cover",
              render_type !== "page" ? "rounded-r-xl" : null
            )}
            alt="BangDB Signup Image"
            src={bgImage}
          />
        </div>
      </div>
    </>
  );
}

const randomImages = [
  "/assets/images/bangdb_login_signup_1.jpeg",
  "/assets/images/bangdb_login_signup_2.jpeg"
];

export default Signup;
